import { useNavigate } from "react-router-dom";

type GenerationMode = "standard" | "advanced";

export function GenerationModeTabs({
  taskId,
  active,
  advancedEnabled = true,
  showAdvanced = true,
}: {
  taskId: string;
  active: GenerationMode;
  advancedEnabled?: boolean;
  showAdvanced?: boolean;
}) {
  const navigate = useNavigate();
  const base = `/app/projects/${encodeURIComponent(taskId)}/generating`;

  return <nav className="generation-mode-tabs" aria-label="生成模式">
    <button type="button" className={active === "standard" ? "active" : ""} onClick={() => navigate(base)}>标准模式</button>
    {showAdvanced && <button
      type="button"
      className={active === "advanced" ? "active" : ""}
      disabled={!advancedEnabled}
      title={advancedEnabled ? undefined : "标准模式生成成功后才能使用高级美化"}
      onClick={() => { if (advancedEnabled) navigate(`${base}?mode=advanced`); }}
    >高级美化</button>}
  </nav>;
}
